<template>
  <b-card class="ba-h-full ba-overflow-auto">
    <button @click="dialogVisible = true">Open DWG/DXF Viewer</button>
    <vis-modal
      :visible.sync="dialogVisible"
      title="DWG/DXF viewer"
      fullHeight
      no-content-padding
    >
      <vis-dxf-viewer :file-url="fileUrl" />
    </vis-modal>
  </b-card>
</template>

<script>
export default {
  name: "v-dxf-viewer-page",
  components: {},
  data() {
    return {
      dialogVisible: false,
      fileUrl: "/static/dxf/model/test.dxf"
    };
  }
};
</script>
